import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { DEFAULT_SETTINGS, initialState, reducer, StoreProvider, type State } from './state/store';
import { loadProject, loadSettings } from './lib/storage';
import './styles.css';

/** Rebuilds the last session from localStorage so a refresh never loses work. */
function restoreState(): State {
  const settings = { ...DEFAULT_SETTINGS, ...(loadSettings() ?? {}) };
  const project = loadProject();
  const base: State = { ...initialState, settings };
  if (!project || project.files.length === 0) return base;

  const restored = reducer(base, {
    type: 'loadFiles',
    files: project.files,
    replace: true,
  });
  return {
    ...restored,
    mapId: project.mapId ?? base.mapId,
    mapSize: project.mapSize ?? base.mapSize,
    past: [],
    future: [],
    dirty: false,
    notice: { kind: 'info', text: `Restored ${project.files.length} file(s) from your last session.` },
  };
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <StoreProvider preloaded={restoreState()}>
      <App />
    </StoreProvider>
  </StrictMode>,
);
